import { userConstants } from '../_constants';

export function resetPass(state = {}, action) {
  switch (action.type) {
    case userConstants.RESETPASS_REQUEST:
      return {
        ...state,
        resetpass: false,
        data: action.pass.data,
      };
    case userConstants.RESETPASS_SUCCESS:
      return {
        ...state,
        resetpass: true,
        data: action.pass.data,
      };
    case userConstants.CLEAR_RESET_PWD_MSG:
      return {
        ...state,
        data: action.payload,
      };
    case userConstants.RESETPASS_FAILURE:
      return {
        ...state,
        resetpass: false,
        data: action.pass.data,
      };
    default:
      return state;
  }
}

export function validateOTP(state = {}, action) {
  switch (action.type) {
    case userConstants.VALIDATEOTP_REQUEST:
      return {
        ...state,
        resetpass: false,
        data: action.otp?.Data,
      };
    case userConstants.VALIDATEOTP_FAILURE:
      return {
        ...state,
        resetpass: false,
        data: action.error?.data,
      };
    default:
      return state;
  }
}
